type ToolbarTooltipEntry = { selector: string; title: string };

export function annotateToolbarTooltips(toolbar: HTMLElement, entries: ToolbarTooltipEntry[]): void {
  entries.forEach(({ selector, title }) => {
    const el = toolbar.querySelector(selector);
    if (el) {
      el.classList.add("global-tooltip-trigger");
      el.setAttribute("title", title);
    }
  });
}
